import { render, staticRenderFns } from "./InfoFamiliar.vue?vue&type=template&id=3703640f&scoped=true"
import script from "./InfoFamiliar.vue?vue&type=script&lang=js"
export * from "./InfoFamiliar.vue?vue&type=script&lang=js"
import style0 from "./InfoFamiliar.vue?vue&type=style&index=0&id=3703640f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703640f",
  null
  
)

export default component.exports